var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c("address-view", {
        attrs: {
          addresses: _vm.entity.addresses,
          "is-tiled": true,
          v: _vm.$v.entity.addresses,
        },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }